<template>
  <div class="card bg-base-200 hover:bg-base-300 transition-colors">
    <div class="card-body">
      <h3 class="card-title text-lg">{{ competition.name }}</h3>
      
      <div class="space-y-2 text-sm">
        <div class="flex justify-between">
          <span class="text-base-content/70">Starts:</span>
          <span>{{ new Date(competition.start_date).toLocaleDateString() }}</span>
        </div>
        <div class="flex justify-between">
          <span class="text-base-content/70">Duration:</span>
          <span>{{ competition.duration_days }} days</span>
        </div>
        <div class="flex justify-between">
          <span class="text-base-content/70">Stocks:</span>
          <span>{{ competition.required_stock_count }}</span>
        </div>
        <div class="flex justify-between">
          <span class="text-base-content/70">Type:</span>
          <span class="capitalize">{{ competition.is_public ? 'Public' : 'Private' }}</span>
        </div>
        <div class="flex justify-between">
          <span class="text-base-content/70">Weights:</span>
          <span :class="competition.allow_weights ? 'text-success' : 'text-base-content/70'">
            {{ competition.allow_weights ? 'Enabled' : 'Disabled' }}
          </span>
        </div>
        <div v-if="competition.is_public && competition.max_participants" class="flex justify-between">
          <span class="text-base-content/70">Max Participants:</span>
          <span>{{ competition.max_participants }}</span>
        </div>
        <div v-if="!competition.is_public" class="flex justify-between">
          <span class="text-base-content/70">Stock Uniqueness:</span>
          <span :class="competition.stock_uniqueness_enabled ? 'text-warning' : 'text-base-content/70'">
            {{ competition.stock_uniqueness_enabled ? 'Enforced' : 'Not Enforced' }}
          </span>
        </div>
      </div>

      <div class="card-actions justify-end mt-4">
        <router-link 
          :to="`/competition/${competition.id}`" 
          class="btn btn-ghost btn-sm"
        >
          View Details
        </router-link>
        <router-link 
          :to="`/join-form?id=${competition.id}`" 
          class="btn btn-primary btn-sm"
        >
          Join Competition
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  competition: {
    type: Object,
    required: true
  }
})
</script> 